/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many people report it takes roughly 15-20 minutes of uninterrupted work to reach full focus after starting or after an interruption. That's a large share of a 1-hour block, which is why protecting the full hour from check-ins matters more than the total time spent.`)
};

const es_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muchas personas reportan que se necesitan aproximadamente 15-20 minutos de trabajo ininterrumpido para alcanzar la concentración plena después de empezar o tras una interrupción. Eso es una gran parte de un bloque de 1 hora, razón por la cual proteger la hora completa de revisiones importa más que el tiempo total invertido.`)
};

const de_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viele Menschen berichten, dass es etwa 15-20 Minuten ununterbrochener Arbeit braucht, um nach dem Start oder einer Unterbrechung vollen Fokus zu erreichen. Das ist ein großer Anteil eines 1-Stunden-Blocks — ein Grund, warum es wichtiger ist, die volle Stunde vor Check-ins zu schützen, als die aufgewendete Gesamtzeit.`)
};

const nl_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veel mensen geven aan dat het ongeveer 15-20 minuten ononderbroken werk kost om volledige focus te bereiken na het begin of na een onderbreking. Dat is een groot deel van een blok van 1 uur, wat verklaart waarom het beschermen van het volledige uur tegen check-ins belangrijker is dan de totale bestede tijd.`)
};

const fr_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beaucoup rapportent qu’il faut environ 15 à 20 minutes de travail ininterrompu pour atteindre une pleine concentration après avoir commencé ou après une interruption. Cela représente une part importante d’un bloc d’une heure, c’est pourquoi protéger l’heure entière des vérifications compte plus que le temps total passé.`)
};

const it_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molte persone riportano che occorrono circa 15-20 minuti di lavoro ininterrotto per raggiungere la piena concentrazione dopo l'inizio o dopo un'interruzione. Si tratta di una porzione consistente di un blocco di 1 ora, motivo per cui proteggere l'intera ora dai controlli conta più del tempo totale impiegato.`)
};

const pt_br2_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas pessoas relatam que leva cerca de 15-20 minutos de trabalho ininterrupto para atingir o foco total depois de começar ou depois de uma interrupção. Isso representa uma grande parte de um bloco de 1 hora, o que explica por que proteger a hora inteira de checagens importa mais do que o tempo total gasto.`)
};

const pt_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas pessoas relatam que demoram cerca de 15-20 minutos de trabalho ininterrupto para atingir o foco total depois de começar ou depois de uma interrupção. Isso é uma grande parte de um bloco de 1 hora, razão pela qual proteger a hora completa de verificações importa mais do que o tempo total gasto.`)
};

const ja_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多くの人は、開始時や中断後に完全に集中するまでにおよそ15〜20分の中断のない作業が必要だと報告しています。これは1時間のブロックのかなりの割合を占めており、だからこそ丸1時間を確認作業から守ることが、費やした総時間よりも重要になるのです。`)
};

const zh_timer_u1h_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`许多人反映，开始工作或被打断后，大约需要15-20分钟不受打扰的工作才能达到完全专注。这占了1小时时段中相当大的比例，因此保护整个小时不被查看打断，比总耗时本身更重要。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1h_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1h_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1h_faq3_a", locale)
	if (locale === "en") return en_timer_u1h_faq3_a(inputs)
	if (locale === "es") return es_timer_u1h_faq3_a(inputs)
	if (locale === "de") return de_timer_u1h_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u1h_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u1h_faq3_a(inputs)
	if (locale === "it") return it_timer_u1h_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1h_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u1h_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u1h_faq3_a(inputs)
	return zh_timer_u1h_faq3_a(inputs)
};